import { DashboardLateralNav } from 'components/DashboardLateralNav';
import { AudioEnableInteractionModal } from 'components/molecules/modals/AudioEnableInteractionModal';
import { Navbar } from 'components/Navbar';
import { PetProvider, TreatmentProvider } from 'context';
import { TreatmentInQueueProvider } from 'context/TreatmentInQueueContext';
import { useDisclose } from 'hooks/utilHooks';
import { FC, useEffect, useState } from 'react';
import { Route, Switch, useRouteMatch } from 'react-router-dom';

import HistoryIcon from '@mui/icons-material/History';
import SettingsIcon from '@mui/icons-material/Settings';
import VideoCallIcon from '@mui/icons-material/VideoCall';
import { Box, Container, Toolbar } from '@mui/material';

import { Appointment } from './Appointment';
import { Dashboard } from './Dashboard';
import { Historic } from './Historic';
import { HistoricPet } from './Historic/HistoricPet';
import { VetProfile } from './Profile';
import { TreatmentOnGoingScreen } from './TreatmentOnGoing';

export const Vet: FC = () => {
  const { path } = useRouteMatch();
  const [items, setItems] = useState([{}]);
  const [openSideMenu, setOpenSideMenu] = useState(true);
  const [pageTitle, setPageTitle] = useState('Atendimento');
  const audioEnableInteractionModal = useDisclose(true);

  const toggleDrawer = () => {
    setOpenSideMenu(!openSideMenu);
  };

  useEffect(() => {
    setItems([
      {
        id: 0,
        name: 'Atendimento',
        url: path,
        component: <VideoCallIcon />,
      },
      /* {
        id: 1,
        name: 'Meu Histórico',
        url: `${path}/historic`,
        component: <HistoryIcon />,
      }, */
      {
        id: 2,
        name: 'Configurações',
        url: `${path}/settings`,
        component: <SettingsIcon />,
      },
    ]);
  }, [path]);

  return (
    <Box sx={{ display: 'flex' }}>
      <DashboardLateralNav
        openSideMenu={openSideMenu}
        toggleDrawer={toggleDrawer}
        items={items}
        setPageTitle={setPageTitle}
      />
      <Navbar
        openSideMenu={openSideMenu}
        toggleDrawer={toggleDrawer}
        pageName={pageTitle}
      />
      <Box
        component="main"
        sx={{
          backgroundColor: '#ffffff',
          flexGrow: 1,
          height: '100vh',
          overflow: 'auto',
        }}
      >
        <Toolbar />
        <Container sx={{ py: 3 }}>
          <Switch>
            <Route exact path={path}>
              <PetProvider>
                <Dashboard />
              </PetProvider>
            </Route>

            <Route exact path={`${path}/settings`}>
              <VetProfile />
            </Route>

            <Route exact path={`${path}/video-call`}>
              <PetProvider>
                <TreatmentProvider>
                  <TreatmentOnGoingScreen />
                </TreatmentProvider>
              </PetProvider>
            </Route>

            <Route exact path={`${path}/appointment`}>
              <TreatmentInQueueProvider>
                <Appointment />
              </TreatmentInQueueProvider>
            </Route>

            <Route exact path={`${path}/historic`}>
              <Historic />
            </Route>

            <Route exact path={`${path}/historic/historicPet`}>
              <HistoricPet />
            </Route>
          </Switch>
        </Container>
      </Box>

      <AudioEnableInteractionModal
        open={audioEnableInteractionModal.isOpen}
        onClose={audioEnableInteractionModal.onClose}
      />
    </Box>
  );
};
